<template>
  <layout-center>
    <form>
      <v-card v-if="item">
        <v-card-title>
          <div class="title">
            {{ $lang(item.id ? "UPDATE" : "NEW") + " " + $lang("TAG") }}
          </div>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <selector-tag-ident
            :select="item.ident"
            @selected="(abbr) => (item.ident = abbr)"
          />
        </v-card-text>

        <v-divider></v-divider>

        <common-create-fields :item="item" />

        <v-card-actions>
          <div class="text-xs-center">
            <v-btn outlined @click="doSubmit">{{
              $lang(item.id ? "UPDATE" : "CREATE")
            }}</v-btn>
            <v-btn
              text
              @click="$router.push({ name: 'dashboard-prep-tags' })"
              >{{ $lang("CANCEL") }}</v-btn
            >
          </div>
          <v-spacer></v-spacer>
          <v-btn v-if="item.id" color="red" outlined @click="remove()">
            <v-icon>mdi-delete</v-icon> {{ $lang("REMOVE") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </layout-center>
</template>

<script>
import { mapGetters } from "vuex";
import LayoutCenter from "@/layouts/LayoutCenter.vue";
import CommonCreateFields from "../../modules/CommonCreateFields.vue";
import SelectorTagIdent from "../../modules/SelectorTagIdent";

export default {
  name: "dashboard-prep-tags-create",
  components: {
    LayoutCenter,
    CommonCreateFields,
    SelectorTagIdent,
  },
  data() {
    return {
      item: {
        id: null,
        title: "",
        description: "",
        language: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      auth: "auth/auth",
    }),
    errors: {
      get() {
        return this.$store.getters.getFormErrors;
      },
      set(_) {},
    },
  },
  watch: {},
  methods: {
    remove() {
      this.$store
        .dispatch("dashboard/prep/TagsRemove", {
          item: this.item,
          context: this,
        })
        .then(() => {
          this.$router.replace({ name: "dashboard-prep-tags" });
        });
    },
    fetchItem(id) {
      this.item.id = this.$route.params.id;
      this.$store
        .dispatch("dashboard/prep/TagsGetOne", {
          id: this.item.id,
          context: this,
        })
        .catch(() => {
          this.$router.replace({ name: "dashboard-prep-tags" });
        });
    },
    doSubmit() {
      if (this.$route.params.id) {
        this.$store.dispatch("dashboard/prep/TagsUpdate", {
          item: this.item,
          context: this,
        });
      } else {
        this.$store
          .dispatch("dashboard/prep/TagsCreate", {
            item: this.item,
            context: this,
          })
          .then((data) => {
            this.$router.replace({
              name: "dashboard-prep-tags-create",
              params: { id: data.id },
            });
          });
      }
    },
  },
  watch: {
    "$route.params.id"(id) {
      this.fetchItem(id);
    },
  },
  created() {
    if (this.$route.params.id) {
      this.fetchItem(this.$route.params.id);
    }
  },
};
</script>
